var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 109,
    viewBox: "0 0 110 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 109,
    height: 109,
    rx: 54.5,
    fill: "#EBECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9987 54.5001C60.6136 54.5001 65.1654 49.9483 65.1654 44.3334C65.1654 38.7185 60.6136 34.1667 54.9987 34.1667C49.3838 34.1667 44.832 38.7185 44.832 44.3334C44.832 49.9483 49.3838 54.5001 54.9987 54.5001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3346 72.2917V74.8334C75.3346 75.5075 75.0669 76.154 74.5902 76.6306C74.1135 77.1073 73.4671 77.3751 72.793 77.3751H37.2096C36.5355 77.3751 35.8891 77.1073 35.4124 76.6306C34.9358 76.154 34.668 75.5075 34.668 74.8334V72.2917C34.668 68.2472 36.2747 64.3683 39.1346 61.5084C41.9945 58.6484 45.8734 57.0417 49.918 57.0417H60.0846C64.1292 57.0417 68.0081 58.6484 70.868 61.5084C73.7279 64.3683 75.3346 68.2472 75.3346 72.2917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.fa5929403570b1e8e038388109703ec2.svg";
export { ForwardRef as ReactComponent };